/*
 * @Author: 小周
 * @Date: 2022-05-30 15:28:33
 * @LastEditTime: 2022-05-30 15:37:46
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: 微信分享配置
 */

const appId = 'wx7014578640c0509c';
const shareLink = '';
const shareTitle = '';
const shareDesc = '大象新闻';
const shareImg = `https://res.hntv.tv/icon/share-dx.png`;

export { appId, shareLink, shareTitle, shareDesc, shareImg };
